export const selectStore = (state) => state.store

export const selectInit = (state) => selectStore(state).init
